<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você poderá vincular investidores ao fundo de investimento.
              Para tal, o investidor já deverá ter criado uma conta e estar
              devidamente cadastrado.
            </p>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--8">
      <div class="row mb-4">
        <div class="col-12">
          <card shadow footerClasses="pt-2 pb-3 text-center">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">
                    Fundo de Investimentos
                    <span class="text-warning">STARS</span>
                  </h3>
                </div>
              </div>
            </div>
            <template>
              <div class="row text-center">
                <div class="col-md-4">
                  <img src="/img/pages/fund.png" width="100" alt="..." />
                  <h3 class="mt-2">{{ fund.tag }}</h3>
                  <badge type="info">{{ getTypeLabel(fund.type) }}</badge>
                </div>
                <div class="col-md-8">
                  <div
                    class="card-profile-stats d-flex justify-content-center small pb-0 mb-1 pt-1"
                  >
                    <div>
                      <span class="heading">{{ fund.batches || "-" }}</span>
                      <span class="description">Batches</span>
                    </div>
                    <div>
                      <span class="heading">{{ formatValue(fund.value) }}</span>
                      <span class="description">Valor</span>
                    </div>
                    <div>
                      <span class="heading">{{
                        fund.number_investors || "-"
                      }}</span>
                      <span class="description">Investidores</span>
                    </div>
                  </div>
                  <h4 class="mt-4">
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i>{{ fund.city || "..." }},
                      {{ fund.state || "..." }}
                    </div>
                  </h4>
                  <h4>
                    Duração:
                    <span class="font-weight-light">
                      {{ formatDate(fund.start_date, "L") || "..." }} até
                      {{ formatDate(fund.end_date, "L") || "..." }}
                    </span>
                  </h4>
                </div>
              </div>
            </template>
            <div slot="footer">
              <base-button
                class="mt-2"
                type="white"
                @click="$router.push(`/admin/fundos/${fund.id}/editar`)"
                ><i class="fas fa-edit text-info mr-2"></i>Editar
                fundo</base-button
              >
              <base-button
                class="mt-2"
                type="white"
                @click="$router.push(`/admin/fundos/${fund.id}/batches`)"
                ><i class="fas fa-award mr-2 text-dark-green"></i>Gerenciar
                batches</base-button
              >
            </div>
          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Investidores participantes do fundo</h3>
                </div>
              </div>
            </div>
            <template>
              <form
                @submit.prevent
                class="vld-parent"
                ref="form_edit_container"
              >
                <div class="pl-lg-4 pl-md-0">
                  <div class="row">
                    <div class="col-sm-12 col-lg-8">
                      <div class="vld-parent" ref="input_investors">
                        <v-select
                          class="investors_select"
                          placeholder="Busque por um investidor (nome ou email)"
                          label="name"
                          :options="investors"
                          :filter-by="filterByNameOrEmail"
                          v-model="selectedInvestor"
                          @input="handleSelectInvestor"
                        >
                          <template v-slot:option="option">
                            <i class="fas fa-user mr-2"></i>
                            {{ option.name }}
                            <span class="float-right text-xs"
                              ><i class="fas fa-envelope mr-1"></i>
                              {{ option.user.email }}</span
                            >
                          </template>
                          <span slot="no-options">Não há investores</span>
                        </v-select>
                      </div>
                    </div>
                    <div
                      class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4 my-3 my-lg-0 text-center"
                    >
                      <base-button
                        :custom="true"
                        size="lg"
                        @click="handleAddInvestor"
                        icon="fas fa-user-plus"
                        >Adicionar ao fundo</base-button
                      >
                    </div>
                    <div class="col-12 text-right mt-2 text-muted">
                      Investores selecionados até o momento:
                      <b>{{ selectedInvestors.length }}</b>
                    </div>
                  </div>
                </div>
              </form>
            </template>
          </card>
          <div class="col mt-3">
            <div v-if="!selectedInvestors.length">
              <div class="row">
                <div class="col">
                  <p
                    class="text-warning rounded shadow-lg p-3 bg-white text-center"
                  >
                    Nenhum investidor selecionado até o momento. Selecione-os a
                    partir da caixa de busca.
                  </p>
                </div>
              </div>
            </div>
            <div v-else class="card-deck vld-parent" ref="investors_list">
              <div
                class="col-md-6 col-xs-12 mt-5 d-flex align-items-stretch"
                v-for="investor in selectedInvestors"
                :key="'selected_investor_' + investor.user_id"
              >
                <div class="card text-center flex-grow-1">
                  <div class="card-profile-image">
                    <img
                      :src="investor.profilePicture.url"
                      class="card-image my-3"
                      alt="..."
                    />
                  </div>
                  <div class="card-body mt-8 pt-0 pb-2">
                    <p class="card-title h3 mb-1 text-warning">
                      {{ investor.name }}
                    </p>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="ni ni-pin-3 mr-2"></i
                        >{{ investor.city || "..." }},
                        {{ investor.state || "..." }}
                      </div>
                      <div>
                        <div class="h5 font-weight-300 mb-1">
                          <i class="fas fa-envelope mr-2"></i
                          >{{ investor.user.email }}
                        </div>
                      </div>
                      <div class="h5 mt-3">
                        <badge
                          type="info"
                          class="text-dark"
                          title="Local de trabalho"
                        >
                          <i class="fas fa-briefcase mr-1"></i>
                          <span class="font-weight-bold">
                            {{ investor.working_place || "-" }}
                          </span>
                        </badge>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer text-center">
                    <base-button
                      type="white"
                      icon="fas fa-trash text-red"
                      @click="handleRemoveInvestor(investor.user_id)"
                    ></base-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col mt-3 text-center">
            <base-button
              type="primary"
              :custom="true"
              size="lg"
              @click="handleSubmit()"
              :disabled="!isValidModel"
            >
              Salvar fundo
            </base-button>
            <base-alert class="text-center mt-2" v-if="error" type="danger">{{
              error
            }}</base-alert>
          </div>
        </div>
        <div
          class="col-lg-4 order-xl-1 mb-5 mb-xl-0 mt-6 mt-lg-0"
          v-if="selectedInvestorInfo"
        >
          <div class="card text-center">
            <div class="card-profile-image">
              <img
                :src="selectedInvestorInfo.profilePicture.url"
                class="card-image my-3"
                alt="..."
              />
            </div>
            <div class="card-body mt-9 pt-0">
              <p class="card-title h3 mb-1 text-warning">
                {{ selectedInvestorInfo.name }}
              </p>
              <div>
                <div class="h5 font-weight-300 mb-1">
                  <i class="ni ni-pin-3 mr-2"></i
                  >{{ selectedInvestorInfo.city || "..." }},
                  {{ selectedInvestorInfo.state || "..." }}
                </div>
                <div>
                  <div class="h5 font-weight-300 mb-1">
                    <i class="fas fa-envelope mr-2"></i
                    >{{ selectedInvestorInfo.user.email }}
                  </div>
                </div>
                <div class="h5 mt-3">
                  <badge
                    type="info"
                    class="text-dark"
                    title="Local de trabalho"
                  >
                    <i class="fas fa-briefcase mr-1"></i>
                    <span class="font-weight-bold">
                      {{ selectedInvestorInfo.working_place || "-" }}
                    </span>
                  </badge>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  name: "chamada",
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {
        investors: [],
      },
      fund: {
        type: "",
        tag: "",
        state: "",
        city: "",
        start_date: "",
        end_date: "",
        value: "",
        batches: "",
        number_investors: "",
        description: "",
        status: "",
        investors: [],
      },
      investors: [],
      filterByNameOrEmail: (option, label, search) => {
        const temp = search.toLowerCase();
        return (
          option.name.toLowerCase().indexOf(temp) > -1 ||
          option.user.email.toLowerCase().indexOf(temp) > -1
        );
      },
      selectedInvestor: "",
      selectedInvestorInfo: "",
      selectedInvestors: [],
      error: "",
      modals: {
        emptyInvestors: false,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.form_edit_container,
      width: 140,
      height: 140,
    });
    await this.loadFund();
    await this.loadInvestors();
    loader.hide();
  },
  methods: {
    async loadData(
      endpoint,
      targetObjName,
      loaderRef,
      emptyModalRef,
      errorMsg
    ) {
      const loader = this.$loading.show({
        container: loaderRef,
        width: 90,
        height: 90,
      });
      try {
        const { data } = await api.get(endpoint);
        if (data.length) this[targetObjName] = data;
        else this.modals[emptyModalRef] = true;
        loader.hide();
      } catch (e) {
        this.$toasted.error(errorMsg);
      }
    },
    async loadFund() {
      try {
        const { data } = await api.get(`/funds/${this.$route.params.id}`);
        Object.assign(this.fund, data);
        this.investors = data.investors;
      } catch (e) {
        this.$toasted.error("Error ao carregar informações do fundo");
        this.$router.push("/");
      }
    },
    async loadInvestors() {
      // load all startups
      await this.loadData(
        "/adm/investors",
        "investors",
        this.$refs.input_investors,
        "emptyInvestors",
        "Ocorreu um erro ao recuperar os investidores"
      );
      // fix profile pictures
      const defaultProfilePicture = "/img/pages/default_profile_picture.png";
      this.investors.forEach((investor) => {
        if (!investor.profilePicture)
          investor.profilePicture = { url: defaultProfilePicture };
      });
      // add fund_investors in the selected list
      this.fund.investors.forEach((investor) => {
        this.swipeBetweenLists(
          this.investors,
          this.selectedInvestors,
          investor.investor_id
        );
      });
    },
    handleSelectInvestor() {
      this.selectedInvestorInfo = this.selectedInvestor;
    },
    handleAddInvestor() {
      if (!this.selectedInvestor) return;
      this.swipeBetweenLists(
        this.investors,
        this.selectedInvestors,
        this.selectedInvestor.user_id
      );
      this.selectedInvestor = "";
      this.selectedInvestorInfo = false;
    },
    handleRemoveInvestor(id) {
      this.swipeBetweenLists(this.selectedInvestors, this.investors, id);
    },
    swipeBetweenLists(source, target, investorId) {
      const index = source
        .map((startup) => {
          return startup.user_id;
        })
        .indexOf(investorId);
      if (index !== -1) target.push(...source.splice(index, 1));
    },
    async handleSubmit() {
      this.error = "";
      const investorsIds = this.selectedInvestors.map(function (investor) {
        return investor.user_id;
      });
      this.model.investors = investorsIds;
      try {
        await api.put(`/funds/${this.$route.params.id}`, this.model);
        this.$toasted.show("Investidores inseridos com sucesso");
        this.$router.push({ name: "admin_fundos" });
      } catch (e) {
        this.error =
          "Ocorreu um erro ao inserir os investidores no fundo. Por favor, tente novamente.";
        this.$toasted.error(
          "Ocorreu um erro ao inserir os investidores no fundo"
        );
      }
    },
    getTypeLabel(fundType) {
      const separator = fundType === "Misto" ? "" : "de";
      return `Fundo ${separator} ${fundType}`;
    },
  },
  computed: {
    isValidModel() {
      return this.selectedInvestors.length > 0;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 130px;
  height: 130px;
  border-radius: 10%;
  margin: auto;
}
</style>
<style>
.investors_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
  border: 0.3px solid #cad1d7;
  border-radius: 0.375rem;
}
.investors_select.v-select .vs__dropdown-toggle {
  padding: 8px;
}
.investors_select.v-select
  .vs__dropdown-toggle
  .vs__selected-options
  .vs__search {
  color: #8898aa;
  line-height: 1.5;
  font-weight: 400;
}
</style>
